const sneakersCatalog = [
  {
    id: 0, 
    name: "Adidas Marathon",
    brand: "Adidas",
    size: 9.5,
    quantity: 20,
    price: 15, 
    img: '/imgs/sneakers/Adidas Marathon.jpg',
    description: `
    Incredibly stylish, these running shoes for men are engineered with EVA midsole and MemoryTech Massage sockliner for responsive cushioning and increased flexibility. Featuring a textile upper for ultimate breathability, these shoes are detailed with a tough rubber outsole for the best surface traction.
    `,
    inCart: false,
  }, 
  {
    id: 1, 
    name: "New Balance 999",
    brand: "New Balance",
    size: 12,
    quantity: 15,
    price: 100, 
    img: '/imgs/sneakers/New Balance 999.jpg',
    description: `
    Energize your run while staying comfortable with this new design, your ride will be smooth and effortless. Breathable mesh upper for maximum ventilation and a cushioned IMEVA midsole provides all-day comfort with rubber outsole for best durability in high wear areas.
    `,
    inCart: false,
  }, 
  {
    id: 2, 
    name: "Nike Air Max 1",
    brand: "Nike",
    size: 7,
    quantity: 10,
    price: 70, 
    img: '/imgs/sneakers/Nike Air Max 1.jpg',
    description: `
     Men's Nike Air Max 1 Training Shoe sets you up for comfortable training with durable leather on top for support. A lightweight foam midsole with a full-length encapsulated Air-Sole unit cushions every stride in the Nike men's shoe.
    `,
    inCart: false,
  }, 
  {
    id: 3, 
    name: "Nike Flyknit Trainer",
    brand: "Nike",
    size: 11,
    quantity: 5,
    price: 65, 
    img: '/imgs/sneakers/Nike Flyknit Trainer.jpg',
    description: `
    The Nike Epic React Flyknit takes a step up from its predecessor with smooth, lightweight performance and a bold look. An updated Flyknit upper conforms to your foot with a minimal, supportive design. Underfoot, durable Nike React technology defies the odds by being both soft and responsive, for comfort that lasts as long as you can run.
    `,
    inCart: false,
  }, 
  {
    id: 4, 
    name: "Nike Lunar Force",
    brand: "Nike",
    size: 10,
    quantity: 17,
    price: 120, 
    img: '/imgs/sneakers/Nike Lunar Force.jpg',
    description: `
    The Nike Lunar Force gives you trusted stability for miles with athlete-informed performance. Made for dependability on your long runs, its intuitive design offers a locked-in fit and a durable feel.
    `,
    inCart: false,
  }, 
  {
    id: 5, 
    name: "Reebok DMX Run 10",
    brand: "Reebok",
    size: 11.5,
    quantity: 50,
    price: 35, 
    img: '/imgs/sneakers/Reebok DMX Run 10.jpg',
    description: `
    The Reebok DMX Run 10 takes a step up from its predecessor with smooth, lightweight performance and a bold look. An updated Flyknit upper conforms to your foot with a minimal, supportive design. Underfoot, durable Reebok React technology defies the odds by being both soft and responsive, for comfort that lasts as long as you can run.
    `,
    inCart: false,
  }, 
  {
    id: 6, 
    name: "Reebok Super Run",
    brand: "Reebok",
    size: 10.5,
    quantity: 1000,
    price: 55, 
    img: '/imgs/sneakers/Reebok Super Run.jpg',
    description: `
      Energize your run while staying comfortable with this new design, your ride will be smooth and effortless. Breathable mesh upper for maximum ventilation and a cushioned IMEVA midsole provides all-day comfort with rubber outsole for best durability in high wear areas.
    `,
    inCart: false,
  }, 
  {
    id: 7, 
    name: "Reebok x Crossover Instapump",
    brand: "Nike",
    size: 8,
    quantity: 30,
    price: 150, 
    img: '/imgs/sneakers/Reebok x Crossover Instapump.jpg',
    description: `
      Incredibly stylish, these running shoes for men are engineered with EVA midsole and MemoryTech Massage sockliner for responsive cushioning and increased flexibility. Featuring a textile upper for ultimate breathability, these shoes are detailed with a tough rubber outsole for the best surface traction.
    `,
    inCart: false,
  }, 
]

export default sneakersCatalog;